import React, { useState, useEffect } from 'react'
import CustomStepper from '../../../BuisnessDashboard/common/CustomStepper'
import AreaCharts from '../../../BuisnessDashboard/common/AreaChart';
import BarMixedCharts from '../../../BuisnessDashboard/common/BarChart';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import { getAggregatorEventsByMonth, getAggregatorAtsByDate, getAggregatorPayoutByDate, getAggregatorLoanStatsByDate, getAggregatorDataByDate } from '../../actioncreator';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION, FILTER_ACTION_RESET } from '../../../../../../reducers/CommonFilters.reducer';
import moment from 'moment';
const months = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 }
];

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

const formatDDMMYYYY = (date) => {
    const dd = String(date.getDate()).padStart(2, "0")
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const yyyy = date.getFullYear()

    return `${dd}-${mm}-${yyyy}`
}


const getDateRangeByType = (type) => {
    const endDate = new Date()
    const startDate = new Date()

    switch (type) {
        case "monthly":
            startDate.setMonth(endDate.getMonth() - 5)
            startDate.setDate(1)
            break

        case "weekly":
            startDate.setDate(endDate.getDate() - 6 * 7)
            break

        case "daily":
            startDate.setDate(endDate.getDate() - 9)
            break

        default:
            break
    }

    return {
        startDate,
        endDate
    }
}


export default function DashboardMain() {
    const dispatch = useDispatch();
    const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState([])
    const [FirstAreachartFilter, setFirstAreachartFilter] = useState({ type: "monthly", apiType: "", apiList: [] })
    const [SecondAreachartFilter, setSecondAreachartFilter] = useState({ type: "monthly", apiType: "", apiList: [] })
    const [FirstMixedchartFilter, setFirstMixedchartFilter] = useState({ type: "monthly", apiType: "", apiList: [] })
    const [firstchartData, setFirstchartData] = useState([])
    const [secondchartData, setsecondchartData] = useState([])
    const [thirdchartData, setthirdchartData] = useState([])
    const [expandedAggregator, setExpandedAggregator] = useState(null);
    const [payload, setPayload] = useState({
        // monthStart: new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1,
        // monthEnd: new Date().getMonth(),
        monthStart: ReducerFrom,
        monthEnd: ReducerTo,
    })

    const [StepperData, setStepperData] = useState([
        { name: "Lead Created", value: "50000", subValue: "Leads", yellowBox: true, hoverData: {} },
        { name: "Basic Information", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        {
            name: "KYC Verification", value: "65000", subValue: "Hits", yellowBox: false, hoverData: {
                apiCost: "₹1800000",
                list: [
                    { name: "Aadhaar", hits: "65000", cost: "₹900000" },
                    { name: "Pan", hits: "65000", cost: "₹900000" },
                ]
            }
        },
        {
            name: "Account Details", value: "65000", subValue: "Hits", yellowBox: false, hoverData: {
                apiCost: "₹1800000",
                list: [
                    { name: "Bank Account Verification", hits: "65000", cost: "₹900000" },
                ]
            }
        },
        { name: "Employment Information", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        {
            name: "Documents", value: "65000", subValue: "Hits", yellowBox: false, hoverData: {
                apiCost: "₹1800000",
                list: [
                    { name: "PDF Parsing by Net Banking", hits: "65000", cost: "₹900000" },
                    { name: "PDF Parsing by Doc Upload", hits: "65000", cost: "₹900000" },
                ]
            }
        },
        { name: "Selfie Verification", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        { name: "Loan Information", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        { name: "Reference Details", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        { name: "Confirmation", value: "10000", subValue: "Users", yellowBox: false, hoverData: {} },
        { name: "Disbursement", value: "50000", subValue: "Leads", yellowBox: true, hoverData: {} },
    ])

    const prevFiltersRef = React.useRef({
        first: FirstAreachartFilter.type,
        second: SecondAreachartFilter.type,
        third: FirstMixedchartFilter.type
    })

    useEffect(() => {
        setPayload({
            monthStart: ReducerFrom,
            monthEnd: ReducerTo,
        })
        callApis()
    }, [ReducerFrom, ReducerTo])

    useEffect(() => {
        const prev = prevFiltersRef.current

        if (FirstAreachartFilter.type !== prev.first) {
            getFirstGraphData()
        }

        if (SecondAreachartFilter.type !== prev.second) {
            getSecondGraphData()
        }

        if (FirstMixedchartFilter.type !== prev.third) {
            getthirdGraphData()
        }

        prevFiltersRef.current = {
            first: FirstAreachartFilter.type,
            second: SecondAreachartFilter.type,
            third: FirstMixedchartFilter.type
        }
    }, [
        FirstAreachartFilter.type,
        SecondAreachartFilter.type,
        FirstMixedchartFilter.type
    ])


    const callApis = () => {
        getStepperData()
        getFirstGraphData()
        getSecondGraphData()
        getthirdGraphData()
        TableDataaFn()
        setExpandedAggregator(null)
    }

    const getStepperData = () => {
        // const start = months.filter((el) => el?.value == payload?.monthStart)
        // const end = months.filter((el) => el?.value == payload?.monthEnd)
        const start = moment(payload?.monthStart).format("DD-MM-YYYY")
        const end = moment(payload?.monthEnd).format("DD-MM-YYYY")
        setLoader(true)
        getAggregatorEventsByMonth(start, end, callback => {
            setLoader(false)
            if (callback?.data?.events?.length > 0) {

                const ar = callback?.data?.events?.map((val, id) => ({
                    name: val?.event?.includes("_") ? val?.event?.replace(/_/g, " ") : val?.event || "",
                    value: val?.count ?? "",
                    subValue: "",
                    yellowBox: id == 0 || id == callback?.data?.events?.length - 1 ? true : false,
                    hoverData: {}
                }))
                console.log("ar", ar)
                setStepperData(ar)

            } else {
                setStepperData([])
            }
        })
    }
    const getFirstGraphData = () => {
        const { startDate, endDate } = getDateRangeByType(FirstAreachartFilter.type)
        setLoader(true)
        getAggregatorAtsByDate(formatDDMMYYYY(startDate),
            formatDDMMYYYY(endDate), FirstAreachartFilter?.type
            , callback => {
                setLoader(false)
                console.log("(callback?.data", callback?.data)
                if (callback?.data) {
                    setFirstchartData(callback?.data)
                } else {
                    setFirstchartData([])
                }
            })
    }
    const getSecondGraphData = () => {
        const { startDate, endDate } = getDateRangeByType(SecondAreachartFilter.type)
        setLoader(true)
        getAggregatorPayoutByDate(formatDDMMYYYY(startDate),
            formatDDMMYYYY(endDate), SecondAreachartFilter?.type
            , callback => {
                setLoader(false)
                console.log("(callback?.data", callback?.data)
                if (callback?.data) {
                    setsecondchartData(callback?.data)
                } else {
                    setsecondchartData([])
                }
            })
    }
    const getthirdGraphData = () => {
        const { startDate, endDate } = getDateRangeByType(FirstMixedchartFilter.type)
        setLoader(true)
        getAggregatorLoanStatsByDate(formatDDMMYYYY(startDate),
            formatDDMMYYYY(endDate), FirstMixedchartFilter?.type
            , callback => {
                setLoader(false)
                console.log("(callback?.data", callback?.data)
                if (callback?.data) {
                    setthirdchartData(callback?.data)
                } else {
                    setthirdchartData([])
                }
            })
    }

    const TableDataaFn = () => {
        // const start = months.filter((el) => el?.value == payload?.monthStart)
        // const end = months.filter((el) => el?.value == payload?.monthEnd)
        const start = moment(payload?.monthStart).format("DD-MM-YYYY")
        const end = moment(payload?.monthEnd).format("DD-MM-YYYY")
        setLoader(true)
        getAggregatorDataByDate(start, end, callback => {
            setLoader(false)
            setTableData(callback?.data ?? [])
        })
    }

    const handlechange = (e, type) => {
        dispatch({ type: FILTER_ACTION, payload: { [type == "monthStart" ? "fromDate" : "toDate"]: e.target.value } });
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleReset = () => {
        dispatch({ type: FILTER_ACTION_RESET });
        setPayload({
            // monthStart: new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1,
            // monthEnd: new Date().getMonth(),
            monthStart: ReducerFrom,
            monthEnd: ReducerTo,
        })
    }

    const handleApplyFilter = () => {
        callApis()

    }

    const handleShowPartners = (aggregator) => {
        setExpandedAggregator((prev) =>
            prev === aggregator.aggregatorId ? null : aggregator.aggregatorId
        );
    };

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='HeadingFilter-main-filters'>
                <div className="row">
                    <div className="col-xl-9 col-lg-10 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                        <div>
                            <label className='customLabel' style={{ display: 'block' }}>Start Date</label>
                            <div className='customInputSearch-bar'>
                                <input className='customInput' type='date' onChange={(e) => handlechange(e, "monthStart")} value={payload?.monthStart} />
                            </div>
                        </div>
                        {/* <select className='customSelectBox' value={payload?.monthStart} onChange={(e) => handlechange(e, "monthStart")}>
                            <option value="">Select Month</option>
                            {
                                months?.map((val) => {
                                    return (
                                        <option value={val?.value}>{val?.label}</option>
                                    )
                                })
                            }
                        </select> */}
                        <div>
                            <label className='customLabel' style={{ display: 'block' }}>End Date</label>
                            <div className='customInputSearch-bar'>
                                <input className='customInput' type='date' onChange={(e) => handlechange(e, "monthEnd")} value={payload?.monthEnd} />
                            </div>
                        </div>
                        {/* <select className='customSelectBox' value={payload?.monthEnd} onChange={(e) => handlechange(e, "monthEnd")}>
                            <option value="">Select Month</option>
                            {
                                months?.map((val) => {
                                    return (
                                        <option value={val?.value}>{val?.label}</option>
                                    )
                                })
                            }
                        </select> */}


                    </div>
                    <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: '5px' }}>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: window.innerWidth > 1200 ? 'end' : "start" }}>
                            <div className='custom-btn' onClick={() => handleApplyFilter()}>
                                <i class="fa fa-filter" aria-hidden="true"></i>
                            </div>

                            <div className='custom-btn' onClick={() => handleReset()}>
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <CustomStepper
                    showOnlyValue={true}
                    Data={StepperData}
                />
            </div>


            <div className='row'>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <AreaCharts
                            showFilters={true}
                            heading={"ATS"}
                            setFilters={setFirstAreachartFilter}
                            chartFilterValues={FirstAreachartFilter}
                            AreaData={firstchartData} xDataKeyName={"monthName"} DataKeyName={"ats"}
                            colorType={"green"} showSelectBox={false} chartHeight={'300'}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <AreaCharts
                            showFilters={true}
                            heading={"Aggregator Payout"}
                            setFilters={setSecondAreachartFilter}
                            chartFilterValues={SecondAreachartFilter}
                            AreaData={secondchartData} xDataKeyName={"monthName"} DataKeyName={"payoutAmount"}
                            colorType={"blue"} showSelectBox={false} chartHeight={'300'}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <BarMixedCharts
                            showFilters={true}
                            chartFilterValues={FirstMixedchartFilter}
                            setFilters={setFirstMixedchartFilter}
                            heading={"Aggregator log Stats"}
                            AreaData={thirdchartData} xDataKeyName={"monthName"} BarDataKeyName={"approvedLeads"} LineDataKeyName={"disbursedLeads"}
                            colorType={"purpleishRed"}
                            LegendLeft={"Approved Leads"} LegendRight={"Disbursed Leads"}
                            showSelectBox={false} chartHeight={'285'}
                        />
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-xs-12">
                    <div className="customDash-table" style={{ marginTop: '20px' }}>
                        <div>
                            <h5>Aggregator Table</h5>
                        </div>
                        <div className='main-customized-table' style={{ overflowY: 'auto', scrollbarWidth: 'thin' }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Aggregator Name</th>
                                        <th>Conversion Ratio</th>
                                        <th>Payout Amount</th>
                                        <th>Committed Leads</th>
                                        <th>Total Disburse Amount Variance</th>
                                        <th>ATS</th>
                                        <th>Total Disbursal Count</th>
                                        <th>Total Budget</th>
                                        <th>Cost Model Type</th>
                                        <th>Total Disburse Variance</th>
                                        <th>Committed Disburse Count</th>
                                        <th>Committed Disburse Amount</th>
                                        <th>Total Leads</th>
                                        <th>CPD</th>
                                        <th>Disbursement Amount</th>
                                        <th>Total Leads Variance</th>

                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        tableData?.length > 0 ? tableData?.map((val, id) => {
                                            return (
                                                <>
                                                    <tr key={id}>
                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRight: '1px solid #eee', borderBottom: '1px solid #eee', background: '#fff' }}>
                                                            {val?.aggregatorName}

                                                            <div
                                                                onClick={() => handleShowPartners(val)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    transform:
                                                                        expandedAggregator === val.aggregatorId
                                                                            ? 'rotate(90deg)'
                                                                            : 'rotate(0deg)',
                                                                    transition: 'transform 0.2s ease',
                                                                }}
                                                            >
                                                                <ArrowRightIcon width={20} height={20} />
                                                            </div>
                                                        </td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.conversionRatio ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.payoutAmount ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.committedLeads ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalDisbAmountVariance ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.ats ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalDisbursalCount ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalBudget ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.costModelType ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalDisbVariance ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.committedDisbCount ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.committedDisbAmount ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalLeads ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.cpd ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.disbursementAmount ?? ""}</td>
                                                        <td style={{ borderBottom: '1px solid #eee' }}>{val?.totalLeadsVariance ?? ""}</td>
                                                    </tr>
                                                    {
                                                        expandedAggregator === val.aggregatorId && (
                                                            <tr>
                                                                <td colSpan={16} style={{ background: '#fafafa', padding: '12px', borderRadius: '8px' }}>
                                                                    <table className="table table-bordered" style={{ borderRadius: '8px' }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th className='customBackgroundcolor' style={{ textAlign: 'left', borderTopLeftRadius: '8px' }}>Partner Name</th>
                                                                                <th className='customBackgroundcolor'>Conversion Ratio</th>
                                                                                <th className='customBackgroundcolor'>Payout Amount</th>
                                                                                <th className='customBackgroundcolor'>Committed Leads</th>
                                                                                <th className='customBackgroundcolor'>Total Disburse Amount Variance</th>
                                                                                <th className='customBackgroundcolor'>ATS</th>
                                                                                <th className='customBackgroundcolor'>Total Disbursal Count</th>
                                                                                <th className='customBackgroundcolor'>Total Budget</th>
                                                                                <th className='customBackgroundcolor'>Total Disburse Variance</th>
                                                                                <th className='customBackgroundcolor'>Committed Disburse Count</th>
                                                                                <th className='customBackgroundcolor'>Committed Disburse Amount</th>
                                                                                <th className='customBackgroundcolor'>Total Leads</th>
                                                                                <th className='customBackgroundcolor'>CPD</th>
                                                                                <th className='customBackgroundcolor'>Disbursement Amount</th>
                                                                                <th className='customBackgroundcolor' style={{ borderTopRightRadius: '8px' }}>Total Leads Variance</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {val?.partners?.map((partner, idx) => (
                                                                                <tr key={idx}>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee', textAlign: 'left', borderBottomLeftRadius: idx + 1 == val?.partners?.length ? '8px' : "" }}>{partner?.partnerName}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.conversionRatio}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.payoutAmount}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.committedLeads}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.totalDisbAmountVariance}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.ats}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.totalDisbursalCount}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.totalBudget}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.totalDisbVariance}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.committedDisbCount}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.committedDisbAmount}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.totalLeads}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.cpd}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.disbursementAmount}</td>
                                                                                    <td style={{ background: '#fff', borderBottom: '1px solid #eee', borderBottomRightRadius: idx + 1 == val?.partners?.length ? '8px' : "" }}>{partner?.totalLeadsVariance}</td>

                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            )
                                        })
                                            : ""}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
